import { toPng } from 'html-to-image';

/**
 * Copy formatted text to clipboard
 */
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Fallback
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    return true;
  }
};

/**
 * Format a chord notepad entry as shareable text
 */
export const formatChordText = (note) => {
  let text = `BEATSEEK | Chord Progression\n`;
  text += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  text += `${note.title || 'Untitled'}\n\n`;
  text += `Chords: ${(note.chords || []).join(' → ')}\n`;
  if (note.key_bpm) text += `Key/BPM: ${note.key_bpm}\n`;
  if (note.bpm) text += `BPM: ${note.bpm}\n`;
  if (note.synth_preset) text += `Preset: ${note.synth_preset}\n`;
  if (note.notes) text += `\nNotes: ${note.notes}\n`;
  text += `\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  text += `beatseek.io`;
  return text;
};

/**
 * Format a scale reference as shareable text
 */
export const formatScaleText = (scaleName, notes, rootNote, aiTips) => {
  let text = `BEATSEEK | Scale Reference\n`;
  text += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  text += `Scale: ${scaleName}\n`;
  text += `Root: ${rootNote}\n`;
  text += `Notes: ${notes}\n`;
  if (aiTips) text += `\nAI Tips: ${aiTips}\n`;
  text += `\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  text += `beatseek.io`;
  return text;
};

/**
 * Generate a branded image card from a hidden DOM element
 */
export const generateShareImage = async (elementId) => {
  const el = document.getElementById(elementId);
  if (!el) return null;

  // Save original position and bring into render zone (behind everything)
  const origLeft = el.style.left;
  const origZIndex = el.style.zIndex;
  el.style.left = '0px';
  el.style.zIndex = '-9999';

  try {
    const dataUrl = await toPng(el, {
      quality: 0.95,
      pixelRatio: 2,
      backgroundColor: '#0a0e1a',
    });
    el.style.left = origLeft;
    el.style.zIndex = origZIndex;
    return dataUrl;
  } catch (e) {
    console.error('Image generation error:', e);
    el.style.left = origLeft;
    el.style.zIndex = origZIndex;
    return null;
  }
};

/**
 * Download a data URL as a file
 */
export const downloadImage = (dataUrl, filename) => {
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
